import type { ClientChatFlagRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useCommunicationChatEventsApi } from '@/features/api/hooks/communication-chat-events/useCommunicationChatEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useFlagChat = () => {
  const queryClient = useQueryClient();
  const api = useCommunicationChatEventsApi();

  return useApiMutation({
    mutationFn: (clientChatFlagRequest: ClientChatFlagRequest) =>
      api.onChatFlagRequest1({ clientChatFlagRequest }),
    onSuccess: (_, { chatId }) => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.CHAT, chatId]
      });
    }
  });
};
